'use strict';

/**
 * @ngdoc function
 * @name thothAppApp.controller:ClientCtrl
 * @description
 * # ClientCtrl
 * Controller of the thothAppApp
 */
angular.module('thothApp.controllers')
  .controller('ClientCtrl', ['$scope', 'Client', 'Pagination', function ($scope, Client, Pagination) {
    const SEARCH_ATTRIBUTES = {
      'search': '',
      'by_column': '',
      'filters': {
        'name': 'fa-sort',
        'client_code': 'fa-sort-asc',
        'rfc': 'fa-sort',
        'complete_name': 'fa-sort',
        'email': 'fa-sort',
        'is_production_ready': 'fa-sort',
        'was_prospect': 'fa-sort'
      }
    };
    $scope.search = SEARCH_ATTRIBUTES;

    $scope.clients = {
      list: [],
      pager: {}
    };

    $scope.getPage = function(page) {
      var params = {
        params: {
          page: page,
          per_page: 10,
          search: $scope.search.search,
          by_column: $scope.search.by_column
        }
      };
      Client.index(params).then(function(response) {
        $scope.clients.list = response.data.clients;
        $scope.clients.pager = Pagination.GetPager(
          response.data.meta.pagination.total_objects,
          page,
          response.data.meta.pagination.per_page);
      },function(error) {
        Client.error(error);
      });
    };

    $scope.clearSearch = function() {
      $scope.search = SEARCH_ATTRIBUTES;
      $scope.search.search = '';
      $scope.getPage(1);
    }

    $scope.pager = {};
    $scope.getPage(1);

    $scope.filter = function(column) {
      var order = '';
      angular.forEach($scope.search.filters, function(value, key) {
        if(column === key) {
          if($scope.search.filters[key] === 'fa-sort-desc') {
            $scope.search.filters[key] = 'fa-sort-asc';
            order = 'ASC';
          } else {
            $scope.search.filters[key] = 'fa-sort-desc';
            order = 'DESC';
          }
        } else {
          $scope.search.filters[key] = 'fa-sort';
        }
      });
      $scope.search.by_column = {
        column: column,
        order: order
      };
      $scope.getPage(1);
    };

    $scope.deleteClient = function(client) {
      var index = $scope.clients.list.indexOf(client);
      Client.delete(client.id).then(function() {
        $scope.clients.list.splice(index, 1);
      }, function(error) {
        Client.error(error);
      });
    };
  }]);
